import { Dependency } from "./dependencies/Dependency";
import { FieldRestriction } from "./FieldRestriction";

export function isHidden(restriction: FieldRestriction) {
    return (restriction != null &&
        restriction.attributes != null &&
        restriction.attributes.includes(RestrictionAttribute.hidden));
}
export function isReadOnly(restriction: FieldRestriction) {
    return (restriction != null &&
        restriction.attributes != null &&
        restriction.attributes.includes(RestrictionAttribute.readonly));
}

export enum RestrictionAttribute {
    required = "required",
    readonly = "read-only",
    hidden = "hidden",
}

export interface Validation { }

export interface SingleValidation extends Validation {
    validator: "length" | "nested" | "presence" | "datetime" | "daterange" | "numeric";
 }

export interface LengthValidation extends SingleValidation {
    validator: "length";
    options: {
        minimum?: number;
    };
}
export interface NumericValidation extends SingleValidation {
    validator: "numeric";
    options: {
        lessThan?: number;
        greaterThan?: number;
    };
}

export function isLengthValidation(arg: any): arg is LengthValidation {
    return arg?.validator === "length";
}
export function isNumericValidation(arg: any): arg is NumericValidation {
    return arg?.validator === "numeric";
}

export interface PresenceValidation extends SingleValidation {
    validator: "presence";
}
export function isPresenceValidation(arg: any): arg is PresenceValidation {
    return arg?.validator === "presence";
}

export interface NestedValidation extends SingleValidation {
    validator: "nested";
    validations: {
        [property: string]: Validation[];
    };
}

export function isNestedValidation(arg: any): arg is NestedValidation {
    return arg?.validator === "nested";
}

export interface DateValidation extends SingleValidation {
    validator: "datetime";
    options: {
        earliest?: Date;
        latest?: Date;
    };
}

export function isDateValidation(arg: any): arg is DateValidation {
    return arg?.validator === "datetime";
}

export interface DateRangeValidation extends SingleValidation {
    validator: "daterange";
    options: {
        earliest?: Date;
        latest?: Date;
    };
}

export function isDateRangeValidation(arg: any): arg is DateRangeValidation {
    return arg?.validator === "daterange";
}

export interface Restriction {}
export interface RestrictionHolder extends Restriction {}

export interface FormRestrictions extends RestrictionHolder, Dictionary<FieldRestriction> {
}

export interface TableRestrictions extends RestrictionHolder, DependencyRestriction, AttributeRestriction {
    filter: FormRestrictions;
    columns: FormRestrictions;
    actions: Dictionary<FormRestrictions>;
    actionButtons: Dictionary<FieldRestriction>;
}
export interface DependencyRestriction extends RestrictionHolder {
    dependencies?: Dependency[];
}
export interface AttributeRestriction extends RestrictionHolder {
    attributes?: RestrictionAttribute[];
}

export interface Dictionary<T> {
    [key: string]: T;
}

